import { render, staticRenderFns } from "./Proveider.vue?vue&type=template&id=b3338094&scoped=true"
import script from "./Proveider.vue?vue&type=script&lang=js"
export * from "./Proveider.vue?vue&type=script&lang=js"
import style0 from "./Proveider.vue?vue&type=style&index=0&id=b3338094&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b3338094",
  null
  
)

export default component.exports